<script setup>
    // import { useRoute } from 'vue-router'
    import Header from '../../components/partials/HeaderPage.vue';
    import SideMenu from '../../components/partials/SideMenu.vue';
    
    // const route = useRoute()
  
</script>

<template>
    <div class="DefaultLayout">
        <Header/>
        <div class="main-content-container">
            <div class="side-menu-container">
                <SideMenu />
            </div>
                
            <!-- <div class="main-content" :class="{'pt-10' : !route.meta.alignSidebar}"> -->
            <div class="main-content">
                <div class="page-content">
                    <main class="w-full px-4">
                        <main class="main-container">
                            <slot/>
                        </main>
                    </main>
                </div>
            </div>
        </div>
    </div>
</template>